import $ from 'cash-dom'
import { register } from 'swiper/element/bundle'
register()

const startAutoplay = ($newSwiper) => {
  if ($newSwiper.swiper && $newSwiper.swiper.autoplay) {
    $newSwiper.swiper.autoplay.start()
  }
}

window.addEventListener('load', () => {
  const $newSwiper = document.querySelector('[data-component="swiper-lcp"]')

  if ($newSwiper) {
    $newSwiper.initialize()
    $($newSwiper).removeClass('hidden')
    $('.lcp-content').hide()

    setTimeout(() => startAutoplay($newSwiper), 2000)

    const event = new CustomEvent('vwoSwiperLoaded')
    window.dispatchEvent(event)
  }
})
